import { InjectionToken } from '@angular/core';
import { AsEntityTypes } from '@frontend-site/shared/data';

/**
 * Neutral contract a single-entity detail page publishes about the entity it currently shows.
 * A detail page implements this and provides itself under {@link ENTITY_CONTEXT_PROVIDER}; the
 * `EntityDetailsSeemoreContextDirective` consumes it. The page itself holds no Seemore knowledge —
 * it only advertises "which entity am I showing", and something else decides what to do with that.
 */
export interface EntityContextProvider {
    readonly entityType: AsEntityTypes;
    /** The entity's user-facing id: appId for most types; the `testId` for TM_TEST; null when none. */
    readonly idForEntityContext: number | null;
    /** The entity's internal PK `id` (server-side-only; seemore redacts it before the model). null when none. */
    readonly internalIdForEntityContext: number | null;
}

/** DI token a detail page registers itself under so a consumer directive can read its {@link EntityContextProvider}. */
export const ENTITY_CONTEXT_PROVIDER = new InjectionToken<EntityContextProvider>('ENTITY_CONTEXT_PROVIDER');
